export default __webpack_public_path__ + "static/media/AdminPannelImg.33ca0b08.png";